import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaximize = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M4 8v-2a2 2 0 0 1 2 -2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M4 16v2a2 2 0 0 0 2 2h2" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 4h2a2 2 0 0 1 2 2v2" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 20h2a2 2 0 0 0 2 -2v-2" })
	]
});
const ForwardRef = forwardRef(SvgMaximize);
export default ForwardRef;
